var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPortalNotFoundCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 458.254,
    height: 248.17,
    viewBox: "0 0 458.254 248.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .portalNotFoundA {\n                fill: #466bb0;\n            }\n\n            .portalNotFoundB {\n                fill: #98b2e0;\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-449.916 -216.987)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(563.456 257.34)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "portalNotFoundA",
    d: "M21.494,87.816,47.228,61.978,21.494,36.142l-2.839,2.851,22.9,22.985-22.9,22.988Z",
    transform: "translate(18.551 15.709)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "portalNotFoundA",
    width: 21.83,
    height: 4.03,
    transform: "translate(78.39 63.254)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "portalNotFoundA",
    width: 32.507,
    height: 4.03,
    transform: "translate(113.805 63.254)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "portalNotFoundA",
    width: 5.724,
    height: 4.03,
    transform: "translate(163.853 63.254)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "portalNotFoundA",
    width: 7.08,
    height: 4.03,
    transform: "translate(185.757 63.254)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "portalNotFoundA",
    width: 21.83,
    height: 4.03,
    transform: "translate(171.005 75.672)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "portalNotFoundA",
    width: 32.501,
    height: 4.03,
    transform: "translate(124.916 75.672)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "portalNotFoundA",
    width: 5.726,
    height: 4.03,
    transform: "translate(101.652 75.672)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "portalNotFoundA",
    width: 7.08,
    height: 4.03,
    transform: "translate(78.39 75.672)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "portalNotFoundA",
    width: 21.83,
    height: 4.03,
    transform: "translate(78.39 88.092)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "portalNotFoundA",
    width: 32.507,
    height: 4.03,
    transform: "translate(113.805 88.092)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "portalNotFoundA",
    width: 5.724,
    height: 4.03,
    transform: "translate(163.853 88.092)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "portalNotFoundA",
    width: 7.08,
    height: 4.03,
    transform: "translate(185.757 88.092)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "portalNotFoundA",
    width: 29.413,
    height: 4.03,
    transform: "translate(38.626 113.393)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "portalNotFoundA",
    width: 43.802,
    height: 4.03,
    transform: "translate(86.348 113.393)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "portalNotFoundA",
    width: 7.715,
    height: 4.03,
    transform: "translate(153.778 113.393)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "portalNotFoundA",
    width: 9.54,
    height: 4.03,
    transform: "translate(183.296 113.393)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "portalNotFoundA",
    width: 29.413,
    height: 4.03,
    transform: "translate(163.422 130.126)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "portalNotFoundA",
    width: 43.799,
    height: 4.03,
    transform: "translate(101.312 130.126)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "portalNotFoundA",
    width: 7.715,
    height: 4.03,
    transform: "translate(69.966 130.126)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "portalNotFoundA",
    width: 9.537,
    height: 4.03,
    transform: "translate(38.626 130.126)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "portalNotFoundA",
    width: 29.413,
    height: 4.03,
    transform: "translate(38.626 146.859)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "portalNotFoundA",
    width: 22.4,
    height: 4.03,
    transform: "translate(86.348 146.859)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "portalNotFoundA",
    width: 7.715,
    height: 4.03,
    transform: "translate(153.778 146.859)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "portalNotFoundA",
    width: 9.54,
    height: 4.03,
    transform: "translate(183.296 146.859)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "portalNotFoundA",
    d: "M221.57,16.843H19.393a14.688,14.688,0,0,0-14.642,14.7v138.02a14.688,14.688,0,0,0,14.642,14.7H221.573a14.688,14.688,0,0,0,14.642-14.7V31.545A14.69,14.69,0,0,0,221.57,16.843ZM232.2,169.564a10.663,10.663,0,0,1-10.629,10.672H19.393A10.663,10.663,0,0,1,8.765,169.564V57.985H232.2v111.58Zm0-115.612H8.762V31.545A10.663,10.663,0,0,1,19.391,20.873H221.57A10.663,10.663,0,0,1,232.2,31.545Z",
    transform: "translate(-4.751 -16.843)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "portalNotFoundA",
    d: "M10.974,32.426H57.318V22.687H10.974Zm4.014-5.709H53.3V28.4H14.988Z",
    transform: "translate(5.678 -6.986)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "portalNotFoundA",
    d: "M87.012,21.559a7.9,7.9,0,1,0,7.867,7.9A7.891,7.891,0,0,0,87.012,21.559Zm0,11.768a3.869,3.869,0,1,1,3.853-3.869A3.866,3.866,0,0,1,87.012,33.327Z",
    transform: "translate(119.925 -8.888)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(812.225 216.987)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "portalNotFoundB",
    width: 57.983,
    height: 4.998,
    rx: 2.499,
    transform: "matrix(0.819, -0.574, 0.574, 0.819, 0, 33.258)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "portalNotFoundB",
    width: 57.983,
    height: 4.998,
    rx: 2.499,
    transform: "matrix(0.766, 0.643, -0.643, 0.766, 3.578, 207.069)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "portalNotFoundB",
    width: 29.992,
    height: 4.999,
    rx: 2.499,
    transform: "matrix(0.891, 0.454, -0.454, 0.891, 32.475, 165.242)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "portalNotFoundB",
    width: 57.119,
    height: 4.284,
    rx: 2.142,
    transform: "translate(38.826 116.714)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "portalNotFoundB",
    width: 27.993,
    height: 4.999,
    rx: 2.499,
    transform: "translate(30.356 69.208) rotate(-22)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(545.861 465.157) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "portalNotFoundB",
    width: 57.983,
    height: 4.998,
    rx: 2.499,
    transform: "matrix(0.819, -0.574, 0.574, 0.819, 0, 33.258)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "portalNotFoundB",
    width: 57.983,
    height: 4.998,
    rx: 2.499,
    transform: "matrix(0.766, 0.643, -0.643, 0.766, 3.578, 207.069)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "portalNotFoundB",
    width: 29.992,
    height: 4.999,
    rx: 2.499,
    transform: "matrix(0.891, 0.454, -0.454, 0.891, 32.475, 165.242)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "portalNotFoundB",
    width: 57.119,
    height: 4.284,
    rx: 2.142,
    transform: "translate(38.826 116.714)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "portalNotFoundB",
    width: 27.993,
    height: 4.999,
    rx: 2.499,
    transform: "translate(30.356 69.208) rotate(-22)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortalNotFoundCard);
export default __webpack_public_path__ + "static/media/portal-not-found-card.ec43f949.svg";
export { ForwardRef as ReactComponent };